import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../services/auth.service";
import { CoachService } from "../services/coach.service";
import * as Global from "src/app/global";
import { NgxSpinnerService } from "ngx-spinner";
import { ErrorService } from "../services/error.service";

@Component({
  selector: "app-dashboard-layout",
  templateUrl: "./dashboard-layout.component.html",
  styleUrls: ["./dashboard-layout.component.scss"]
})
export class DashboardLayoutComponent implements OnInit {
  userDetails: any = this.authService.getCoachSessionDetails();
  Global = Global;
  PageTitle: any;
  notifications: any = [];
  notificationCount: number = 0;
  apiCalling: boolean = false;
  apiCalled: boolean = false;
  show_notification: boolean = false;
  profile_image: string = "";
  base_route: string = "";
  titleRed: boolean = false;
  sportLevel:any;
  select_coach:any;
  constructor(
    private authService: AuthService,
    private coachService: CoachService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private errorService: ErrorService
  ) {
    this.coachService.profileUpdated.subscribe(res => {
      if (res) {
        this.fetchProfileDetails();
      }
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.mobMenu = false;
        this.initPageIndentifier();
        let route = event.url;
        this.base_route = (this.router.url.split('/'))[1] ?? "";


        if (this.base_route == "dashboard") {
          this.PageTitle = `Dashboard`;
        }
        if (this.authService.coachLoggedIn() && (this.base_route == 'availability' || this.base_route == 'dashboard' || this.base_route == 'tutorials' || this.base_route == 'calender' || this.base_route == 'tournaments' || this.base_route == 'requests')) {
          this.fetchNotificationCount();
        }
        if (this.base_route == 'availability' || this.base_route == 'tournaments' || this.base_route == 'requests') {
          this.titleRed = true;
        }
        else {
          this.titleRed = false;
        }
      }
    });

  }

  ngOnInit(): void {
    // this.apiCalling = true;
    // this.fetchNotificationCount();
    this.fetchProfileDetails();
    this.coachService.getSportLevel.subscribe(resp=>{
    if(resp)
    {
      this.sportLevel=resp;
    }
    });
     this.coachService.getCoachDetail.subscribe(resp=>{
    if(resp)
    {
      this.select_coach=resp;
    }
    })


  }

  mobMenu: boolean = false; // hidden by default
  toggleMobMenu() {
    this.mobMenu = !this.mobMenu;
  }

  initPageIndentifier() { }
  fetchNotificationCount() {
    return new Promise((resolve, reject) => {
      this.coachService.countNotification({}).subscribe(
        res => {
          const data = res.data;

          if (data.current_status != "A") {
            // this.router.navigateByUrl('/login');
            this.authService.coachLogout();
            this.toastr.error("Your account has been blocked by admin");
          }
          // console.log(res);
          if (res.status == "success") {
            this.notificationCount = Number(data?.notification_count) ? data?.notification_count : 0;
            this.show_notification = true;
            resolve(true);
          } else {
            this.show_notification = true;

            // this.toastr.error(res.message);
            this.notificationCount = 0;
            reject(res.message);
          }
        },
        err => {
          this.notificationCount = 0;
          this.show_notification = false;
          this.errorService.showError(err);
          //reject(Global.getServerErrorMessage(err));
          this.spinner.hide();
        }
      );
    });
  }
  fetchNotifications() {
    return new Promise((resolve, reject) => {
      if(this.show_notification)
{
  this.coachService.fetchNotifications({ page: 1,limit:5 }).subscribe(
        res => {
          const data = res.data;
          console.log(res);
          this.apiCalling = false;
          this.apiCalled = true;
          if (res.status == "success") {
            this.notifications = res.data.docs
            resolve(true);
          } else {
            // this.toastr.error(res.message);
            this.notifications = [];
            reject(res.message);
          }
        },
        err => {
          this.notifications = [];
          this.errorService.showError(err);
          reject(Global.getServerErrorMessage(err));
        }
      );}
      else
      {
        this.apiCalled = true;
        reject(true)
      }

    });
  }
  navigateToNotification() {
    // navigateToNotifications
    this.coachService.navigateToNotifications.next(true);
    this.router.navigate(["settings"], {
      queryParams: { tab: "notifications" }
    });
  }
  fetchProfileDetails() {
    this.spinner.show();
    this.coachService.coachDetails({}).subscribe(
      res => {
        this.spinner.hide();
        if (res.status == "success") {
          this.userDetails = res.data[0];
          this.profile_image = this.userDetails?.profile_image
        } else {
          // this.toastr.error(res.message);
        }
      },
      err => {
        this.spinner.hide();
        // this.errorService.showError(err);
      }
    );
  }
}
